export function SipCategoryErrorState() {
  return (
    <div className="px-5 py-5 text-[13px] font-[400] leading-[150%] text-[#6A6E6E]">
      We couldn&apos;t load the plan for this category. Please try again later.
    </div>
  )
}
